import { render, staticRenderFns } from "./pro-beseinfo.vue?vue&type=template&id=0e0c7986&scoped=true"
import script from "./pro-beseinfo.vue?vue&type=script&lang=js"
export * from "./pro-beseinfo.vue?vue&type=script&lang=js"
import style0 from "./pro-beseinfo.vue?vue&type=style&index=0&id=0e0c7986&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0c7986",
  null
  
)

export default component.exports